import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/api/login.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';
import { CONSTANTS } from '../../constants';
import { UtilityService } from '../../services/utility.service';
import { SocketService } from '../../services/socket.service';
import { JqueryUtils } from '../../utils/jquery.utils';

import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  username: any;
  instruments: Record<string, any> = new Map<string, any>();
  tokens: any = [];

  constructor(private dataService: DataService,
    private socketService: SocketService, private ls: LoginService,
    private router: Router, private ns: NotificationService,
    private us: UtilityService, private jq: JqueryUtils) { }

  ngOnInit(): void {
    this.subscribeEvents();
    this.username = sessionStorage.getItem(CONSTANTS.COOKIE.USERNAME);
  }

  subscribeEvents() {
    this.socketService.onConnectionInit('header', this);
    this.socketService.priceUpdate(CONSTANTS.SOCKET_IDENTIFIER_KEYS.HEADER, this);
  }

  onPriceUpdate(data: any) {
    if ((this.tokens.indexOf(data.message.Token) > -1)) {
      this.instruments[data.message.Token].price = data.message.Ltp;
    }
  }

  onConnectionInitiated() {
    let details: any = this.dataService.retrieveLiveSocketDetails();
    let t: any = "";
    details.tokens.forEach((token: any) => {
      t = `${token}`;
      if (this.tokens.indexOf(t) == -1) {
        this.tokens.push(t);
      }
      this.instruments[t] = {
        display_name: details.token_map[t],
        token: token,
        price: 0.0
      };
    });
  }

  confirmLogout() {
    this.ls.logout().subscribe((response: any) => {
      if (response.response_code == 1000) {
        sessionStorage.clear();
        this.us.removeAllCookies();
        this.onModalClose();
        this.ns.showAlert(CONSTANTS.SUCCESS, 'Signed out successfully');
        this.router.navigate(['']);
      }
    });
  }

  logout() {
    this.jq.openModal('logoutConfirmationModal');
  }

  onModalClose()
  {
    this.jq.closeModal('logoutConfirmationModal');
  }
}
